import {postLiftingIssue} from '../api/postLifting';
import { setGetUserById } from './setGetUserById';

const setPostLiftingIssue = (params) => {
    return async (dispatch, getState) => {
        try {
            await postLiftingIssue(params);
            dispatch(setGetUserById(params.id))     
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostLiftingIssue
}